import React, { Component } from "react";
import CircleForm from "../../components/CircleForm";
import { connect } from "react-redux";
import { navigate } from "../../store/navigation/operations";
import { loggedInUserGuid, isLoggedIn } from "../../store/iam/selectors";
import { saveCircle, fetchCircle } from "../../store/my_circles/operations";
import { fetchUser } from "../../store/users/operations";
import { savingCircle, getCircleWithId } from "../../store/my_circles/selectors";
import { getUserWithId, isSuperUser } from "../../store/users/selectors";
import validators from "./validators";
import LoadingIndicator from "../../components/LoadingIndicator";
import { fetchSuggestionInCollection } from "../../store/circle_suggestion/operations";
import { selectCollection } from "../../store/home_ui/creators";
import {
  getSuggestionWithId,
  loadingInitialSuggestionsForSelectedCollection,
} from "../../store/circle_suggestion/selectors";

class NewCircle extends Component {
  state = {
    isDrawerOpen: false,
  };

  circle_form = {
    status: "",
    name: "",
    max_owners_no: 2,
    max_active_bookings_per_member: -1,
    max_booking_duration_in_minutes: -1,
    description: "",
    created_by: this.props.myGuid,
    products: [
      {
        name: "",
        url: "",
        base64_image: "",
        currency: "",
        price: "",
        instructions: "",
        pre_owned: false,
      },
    ],
    address: "",
    lat: "",
    lon: "",
    country: "",
    city: "",
    labels: [],
    tags: [],
    is_public: true,
    has_agreement: true,
    door_id: "",
    door_indications_heading: "",
    door_indications_paragraph_1: "",
    door_indications: "",
    door_indications_paragraph_2: "",
    door_indications_image_url: "",
    rentable: false,
    rental_pricing_tier: "",
  };

  componentDidMount() {
    // if(!this.props.isLoggedIn){
    //   return;
    // }
    this.props.fetchUser(this.props.myGuid);
    if (this.props.circleId) {
      this.props.fetchCircle(this.props.circleId);
    } else if (this.props.suggestionId) {
      this.props.selectCollection(this.props.collectionId);
      this.props.fetchSuggestionInCollection(this.props.collectionId, true, this.props.suggestionId);
    }
  }

  checkForUpdates = (circle_details) => {
    let updates = {};
    let self = this;
    Object.keys(this.circle_form).forEach((key) => {
      if (key === "products") {
        Object.keys(this.circle_form.products[0]).forEach((products_key) => {
          if (self.props.circle.products[0][products_key] !== circle_details[products_key]) {
            if (!("products" in updates)) {
              updates["products"] = [{}];
            }
            updates["products"][0][products_key] = circle_details[products_key];
          }
        });
      } else if (key === "labels") {
        const circle_is_prylpoolen = this.props.circle.labels.includes("is_prylpoolen");
        const updated_circle_is_prylpoolen = circle_details.is_prylpoolen;
        if (circle_is_prylpoolen !== updated_circle_is_prylpoolen) {
          if (circle_is_prylpoolen) {
            updates["labels"] = this.props.circle.labels.filter((label) => {
              return label !== "is_prylpoolen";
            });
          } else {
            updates["labels"] = [...this.props.circle.labels, "is_prylpoolen"];
          }
        }
      } else {
        if (["created_by", "tags"].includes(key)) {
          return;
        }

        if (key === "lat") {
          if (this.props.circle.geo_position[0] !== circle_details[key]) {
            updates[key] = String(circle_details[key]);
          }
          return;
        }

        if (key === "lon") {
          if (this.props.circle.geo_position[1] !== circle_details[key]) {
            updates[key] = String(circle_details[key]);
          }
          return;
        }

        if (this.props.circle[key] !== circle_details[key]) {
          updates[key] = circle_details[key];
        }
      }
    });

    if ("products" in updates) {
      updates["products"][0]["guid"] = this.props.circle.products[0].guid;
    }
    return updates;
  };

  createPayload = (circle_details) => {

    Object.keys(this.circle_form).forEach((key) => {
      if (key === "products") {
        Object.keys(this.circle_form.products[0]).forEach((products_key) => {
          this.circle_form.products[0][products_key] = circle_details[products_key];
        });
      } else if (key === "labels" && circle_details.is_prylpoolen) {
        this.circle_form["labels"] = ["is_prylpoolen"];
      } else {
        this.circle_form[key] = circle_details[key] === undefined ? this.circle_form[key] : circle_details[key];
      }
    });

    if (this.props.suggestion) {
      if (this.circle_form.products[0].base64_image === "") {
        delete this.circle_form.products[0]["base64_image"];
        this.circle_form.products[0].image_url = this.props.suggestion.images[0].url;
      }
    }
    if (circle_details["instructions"]) {
      this.circle_form.products[0].instructions = circle_details["instructions"];
    }
    if (this.props.reference && this.props.reference === "whitemonday") {
      this.circle_form.labels = ["whitemonday"];
    }

    return this.circle_form;
  };

  saveCircle = (circle_details) => {
    if (this.props.circleId) {
      const payload = this.checkForUpdates(circle_details);
      if (Object.keys(payload).length) {
        this.props.saveCircle(payload, this.props.circleId);
      }
    } else {
      const payload = this.createPayload(circle_details);
      this.props.saveCircle(payload);
    }
  };

  parseCircleToEdit = (circle) => {
    const parsed_circle = {
      ...circle,
      ...circle["products"][0],
      lat: circle.geo_position[0],
      lon: circle.geo_position[1],
      product_image: circle["products"][0].image_url,
      has_agreement: circle.has_agreement,
      is_prylpoolen: circle.labels.includes("is_prylpoolen"),
    };
    return parsed_circle;
  };

  parseCircleSuggestion = (circle_suggestion) => {
    let parsed_circle = {
      new_circle: true,
      name: circle_suggestion.name,
      price: String(circle_suggestion.total_price),
      currency: circle_suggestion.currency.toUpperCase(),
      url: circle_suggestion.product_url,
      max_owners_no: circle_suggestion.suggested_members_no,
      product_image: circle_suggestion.images[0].url,
    };

    return parsed_circle;
  };

  render() {
    let show_loader = false;
    let user_details = {};
    let edit_circle = undefined;
    let show_agreement_switch = true;
    if (this.props.circleId && !this.props.circle) {
      show_loader = true;
    }

    if (this.props.suggestionId && !this.props.suggestion) {
      show_loader = true;
    }

    if (this.props.circle) {
      edit_circle = this.parseCircleToEdit(this.props.circle);
      show_agreement_switch = false;
    } else if (this.props.suggestion) {
      edit_circle = this.parseCircleSuggestion(this.props.suggestion);
    }

    if (this.props.user) {
      user_details = {
        guid: this.props.myGuid,
        location: { lat: this.props.user.lat, lon: this.props.user.lon },
      };
    }

    return (
      <>
        {!show_loader && (
          <CircleForm
            is_super_user={this.props.is_super_user}
            edit_circle={edit_circle}
            validators={validators}
            onSave={this.saveCircle}
            isSaving={this.props.isSaving}
            myGuid={this.props.myGuid}
            user_details={user_details}
            reference={this.props.reference}
            show_agreement_switch={show_agreement_switch}
          />
        )}
        {show_loader && <LoadingIndicator />}
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  isLoggedIn: isLoggedIn(state),
  locale: state.i18n.locale,
  circle: ownProps.circleId ? getCircleWithId(state, ownProps.circleId) : null,
  myGuid: loggedInUserGuid(state),
  user: getUserWithId(state, loggedInUserGuid(state)),
  isSaving: savingCircle(state),
  loadingCircle: loadingInitialSuggestionsForSelectedCollection(state, true),
  suggestion: getSuggestionWithId(state, ownProps.suggestionId, true),
  is_super_user: isSuperUser(state, loggedInUserGuid(state)),
});

const mapDispatchToProps = {
  navigate,
  saveCircle,
  fetchCircle,
  fetchUser,
  fetchSuggestionInCollection,
  selectCollection,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewCircle);
